// src/pages/Dashboard.jsx
import { useCallback, useEffect, useState } from "react";
import api from "../services/api";
import { formatNumber } from "../utils/numberFormat";


export default function Dashboard() {
  const [estadisticas, setEstadisticas] = useState(null);
  const [mes, setMes] = useState(new Date().getMonth() + 1);
  const [anio, setAnio] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(false);


  const cargarEstadisticas = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get(`/productos/estadisticas?mes=${mes}&anio=${anio}`);
      setEstadisticas(res.data);
    } catch (err) {
      alert("Error al cargar estadísticas. Ver consola para más detalles.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [mes, anio]);


  useEffect(() => {
    cargarEstadisticas();
  }, [cargarEstadisticas]);


  return (
    <div className="dashboard">
      <h1>Dashboard</h1>


      <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
        <select value={mes} onChange={(e) => setMes(Number(e.target.value))}>
          {Array.from({ length: 12 }, (_, i) => (
            <option key={i + 1} value={i + 1}>
              Mes {i + 1}
            </option>
          ))}
        </select>
        <input
          type="number"
          min="2020"
          max="2100"
          value={anio}
          onChange={(e) => setAnio(Number(e.target.value))}
        />
      </div>


      {loading ? (
        <p>Cargando estadísticas...</p>
      ) : estadisticas ? (
        <div className="stats">
          <div className="stat-item red">
            <h2>Total Costos</h2>
            <p>${formatNumber(estadisticas.totalCostos || 0, 2)}</p>
          </div>
          <div className="stat-item green">
            <h2>Total Ganancias</h2>
            <p>${formatNumber(estadisticas.totalGanancias || 0, 2)}</p>
          </div>
        </div>
      ) : (
        <p>No hay datos para este mes.</p>
      )}
    </div>
  );
}

